import styled from "styled-components";
import CloseImg from "@/assets/svg/close.svg";
import DoneImg from "@/assets/svg/down.svg";
import rightArrow from "@/assets/svg/rightArrow.svg";
import arrowD from "@/assets/svg/arrowD.svg";
import StakeArrow from "@/assets/svg/stake_arrow.svg";
import { useAccount } from "wagmi";
import { useContractWrite } from 'wagmi'
import { ReactSVG } from "react-svg";
import { useEffect, useMemo, useState } from "react";
import { ethers } from "ethers";
import TokenModal from "@/components/TokenModal/Modal";
import { arbitrumGoerli } from 'wagmi/chains'
import { jungleAbi, JungleCA } from '@/utils/abi'
import { useDebounce } from '@/hooks/index'
import TradeConfirmModal from '@/components/TradeConfirmModal/Modal'
import { useToastContext } from "@/contexts/ToastContext";
import BTCCImg from '@/assets/imgs/btc.png'
import ETHCImg from '@/assets/imgs/eth.png'
import LINKImg from '@/assets/imgs/link.png'

import { toFixed } from '@/utils/index'

export default function Trade({ handleClose, successCb, info, selectToken, jusdBalance }) {

  const [num, setNum] = useState('')
  const { showToast } = useToastContext();
  const [topVal, setTopVal] = useState('')
  const [botVal, setBotVal] = useState('')
  const [position, setPos] = useState('')  
  const [currentToken, setToken] = useState('')
  const [isOpen, setIsOpen] = useState(false);  
  const [isOpen2, setIsOpen2] = useState(false);
  
  useEffect(() => {
    setToken(info?.coin || {})
  }, [info])  


  const config = {
    mode: 'recklesslyUnprepared',
    address: JungleCA,
    abi: jungleAbi,
    functionName: 'exchange',
    args: [0, 'jUSD', ethers.utils.parseUnits(!isNaN(topVal) && topVal || '0.0', 18), currentToken?.symbol?.split(' ')[0] || 'jBTC' ],
    chainId: arbitrumGoerli.id,
  }
  
  let { data, write, writeAsync, isError } = useContractWrite(config)
  
  const debouncedGetAnotherPosition = useDebounce(() => {

    const price = Number(info.coin.price)

    if(position === 'top'){
      const bot = toFixed(topVal / price, 4)
      setBotVal(bot)
    }else{
      const top = toFixed(botVal * price, 4)
      setTopVal(top)
    }
  });


  const fuck = async()=>{
    try {
      const doIt = await writeAsync()
      const waitData = await doIt.wait()
      if(waitData?.status === 1){
         showToast({
          dir:'center',
          type:'success',
          text:`${toFixed(botVal)} ${currentToken.symbol} Received!`
        })
        successCb()
      }      
    } catch (error) {
      console.log(error);
      successCb()
    }
  }

  const handleChangeTop = (e)=>{
    const val = e.target.value
    setTopVal(val)
    setPos('top')
    if(val === '') return setBotVal('')
    debouncedGetAnotherPosition();
  }
  const handleChangeBot = (e)=>{
    const val = e.target.value
    setBotVal(val)
    setPos('bot')
    if(val === '') return setTopVal('')
    debouncedGetAnotherPosition();
  }

  const handleBuy = ()=>{
    fuck()
    setIsOpen2(true)
  }
  
  const handleMax = (e)=>{    
    setTopVal(`${jusdBalance}`)
    setPos('top')
    debouncedGetAnotherPosition();
  }

  const handleSelect = (e)=>{
    selectToken(e)
    debouncedGetAnotherPosition();
  }

  return (
    <>
      <Modal>
        <div className="close" onClick={handleClose}>
          <ReactSVG src={CloseImg} />
        </div>
        <div className="content">
          <div className="title">{info.dir == 'long' ? 'Buy' : 'Sell'} {currentToken.symbol} With JUSD</div>
          <div className="input">
            <div className="field">
              <input className="input-comp" type="number" value={topVal} placeholder="0.0" onChange={handleChangeTop}/>
              <div className="r">
                <div className="max" onClick={handleMax}>MAX</div>
                <div className="token">
                  {/* <div className="radius"></div> */}
                  <span>jUSD</span>
                </div>
              </div>
            </div>
            <div className="balance">
              <span>${num || '0.00'}</span>
              <span>Balance: {(+jusdBalance).toFixed(2)}</span>
            </div>
          </div>
          <ReactSVG className="stake-arrow" src={StakeArrow} />
          <div className="input input-down">
            <div className="field">
              <input className="input-comp" type="number" value={botVal} placeholder="0.0" onChange={handleChangeBot}/>
              <div className="r" onClick={() => setIsOpen(true)}>
                <div className="token">                  
                  <img className="radius" src={currentToken.symbol === 'jBTC 5x' ? BTCCImg : (currentToken.symbol === 'jETH 5x' ? ETHCImg : LINKImg)} alt="" />
                  <span style={{'paddingRight':'2px'}}>{currentToken.symbol}</span>
                  <ReactSVG src={arrowD} beforeInjection={(svg) => { svg.setAttribute('style', 'display: flex')}}/>
                </div>
              </div>
            </div>
          </div>
          <div className="text-item">1{currentToken.symbol} = {currentToken.price}JUSD</div>
          <div className="text-item">Estimated Fee: 0.03JUSD</div>
          <div onClick={handleBuy} className="stake-btn">Buy</div>
          <div className="text-item">This operation may transfer your Solid JUSD to the debt pool</div>         
        </div>
      </Modal>
      <TokenModal isOpen={isOpen} handleClose={() => setIsOpen(false)} selectToken={handleSelect} currentToken={currentToken} /> 
      <TradeConfirmModal isOpen={isOpen2} handleClose={() => setIsOpen2(false)} token={{left:{name:'jUSD', amount:topVal}, right:{name:currentToken.symbol, amount:botVal}}}/> 
    </>
  );
}

const Modal = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  padding: 34px 35px 0 36px;
  .text-item{
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.6);
    text-align: left;
    width: 100%;
    padding-top: 12px;
  }
  .close {
    position: absolute;
    right: 35px;
    top: 42px;
    cursor: pointer;
  }
  .stake-arrow{
    margin: 10px 0;
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      padding-bottom:26px;
      font-weight: 600;
      font-size: 24px;
      line-height: 34px;
      color: #32DE86;
    }
    .input {
      width: 100%;
      height: 77px;
      padding: 12px 14px;
      box-sizing: border-box;
      background: rgba(255, 255, 255, 0.06);
      border-radius: 8px;
    }    
    .input-down{
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 54px;  
      padding-top: 0;
      padding-bottom: 0;
      line-height: 54px;
      .input-comp {
        max-width: 240px!important;
      }
      .field{
        width: 100%;
        
      }
    }
    .arrow-block{
      padding: 12px 0;
    }
    .space-btw{
      display: flex;
      justify-content: space-between;
      width: 100%;
      font-size: 14px;
      line-height: 17px;
      color: rgba(255, 255, 255, 0.5);
      & + .space-btw {
        margin-top: 8px;
      }
      .line-item{
        display: flex;
        align-items: center;
        .right-arrow{
          margin: 0 5px;
        }
      }
    } 
    .stake-btn{
      width: 100%;
      box-sizing: border-box;
      height: 44px;
      line-height: 44px;
      background: #32DE86;
      border-radius: 8px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      cursor: pointer;
      font-size: 16px;     
      margin-top:15px;
      margin-bottom: 5px;
      &:hover{
        background:#239B5E; 
      }
      &.disabled{
        background: rgba(255, 255, 255, 0.1);
        color: rgba(255, 255, 255, 0.3);
        cursor: auto;
      }
    }
    .field {
      display: flex;
      justify-content: space-between;
      .radius{
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #fff;
        margin-right: 2px;
      }
      .max{
        width: 62px;
        height: 29px;
        line-height: 29px;
        text-align: center;
        border: 1px solid #32DE86;
        color: #32DE86;
        box-sizing: border-box;
        font-weight: 400;
        font-size: 16px;
        border-radius:8px;
        margin-right: 9px;
        cursor: pointer;
      }
      .token{
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 18px;
        line-height: 28px;
      }
      .r{
        display: flex;
        cursor: pointer;
      }
      
      .input-comp {
        background: transparent;
        outline: 0;
        border: 0;
        color: #fff;
        font-weight: 600;
        font-size: 22px;
        max-width: 220px;
        line-height: 22px;        
      }      
      .r{
        display: flex;
        align-items: center;
      }
    }
    .balance{
      display: flex;
      justify-content: space-between;      
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;      
      color: rgba(255, 255, 255, 0.6);
      padding-top: 7px;
    }
  }
`;
